import { render } from "./PayPlans.vue?vue&type=template&id=2e4b3083"
import script from "./PayPlans.vue?vue&type=script&lang=js"
export * from "./PayPlans.vue?vue&type=script&lang=js"

import "./PayPlans.vue?vue&type=style&index=0&id=2e4b3083&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__